var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29 10L39 20L29 30","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M39 20L0 20","stroke":"currentColor","key":1})]);
}

Arrow.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
